import { useEffect, useState } from 'react';

/**
 * Breakpoint mobile do h.lab — alinhado com Tailwind `lg:` (1024px).
 * Mesmo breakpoint usado na Fase 0.5 (responsividade mobile).
 */
const MOBILE_BREAKPOINT_PX = 1024;

/**
 * Retorna true quando o viewport é menor que 1024px (mobile/tablet portrait).
 * Reativo a resize — atualiza em tempo real.
 *
 * SSR-safe: começa como `false` antes do mount, atualiza no client.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < MOBILE_BREAKPOINT_PX;
  });

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`);

    // Sincroniza estado se mudou entre render e effect
    setIsMobile(mq.matches);

    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
